var exports = {
  "Gh": "BlockedUsersTab.module__userList___NGhYc1",
  "Kg": "BlockedUsersTab.module__userCard___NGhYc1",
  "eF": "BlockedUsersTab.module__userInfo___NGhYc1",
  "KI": "BlockedUsersTab.module__avatarButton___NGhYc1",
  "xO": "BlockedUsersTab.module__usernameButton___NGhYc1",
  "QV": "BlockedUsersTab.module__usernameContainer___NGhYc1",
  "Xh": "BlockedUsersTab.module__username___NGhYc1",
  "D2": "BlockedUsersTab.module__discriminator___NGhYc1",
  "o1": "BlockedUsersTab.module__actions___NGhYc1",
  "lK": "BlockedUsersTab.module__moreIcon___NGhYc1",
};

module.exports = exports;
